import { AdminContainer, AlignedListContainer } from "../components/layouts";
import Time from "../lithic/Moment";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import DetailSection from "../components/DetailSection";
import { GutterlessListItem as ListItem } from "../components/lists";
import ListItemText from "@material-ui/core/ListItemText";
import Link from "../components/Link";
import React from "react";
import SimpleTable from "../components/SimpleTable";
import Typography from "@material-ui/core/Typography";
import api from "../api";
import { useParams, useHistory } from "react-router";
import { IdentityStatusBadge } from "../components/IdentityStatusBadge";
import displayPhone from "../modules/displayPhone";
import HiddenSsnDisplay from "../components/HiddenSsnDisplay";

export default function IdentityDetailPage() {
  const { id } = useParams();
  const history = useHistory();
  const [identity, setIdentity] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    setLoading(true);
    setError(null);
    api
      .getIdentity({ id })
      .then(api.pickData)
      .then((data) => {
        setIdentity(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, [id]);

  if (loading)
    return (
      <AdminContainer variant="detail">
        <Typography>Loading...</Typography>
      </AdminContainer>
    );

  if (error) {
    const is404 = error.response?.status === 404;
    return (
      <AdminContainer variant="detail">
        <Typography variant="h6" color="error">
          {is404 ? "Identity not found" : "Error loading identity"}
        </Typography>
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push("/identities")}
          >
            Back to Identities List
          </Button>
        </Box>
      </AdminContainer>
    );
  }

  if (!identity) return null;

  return (
    <AdminContainer variant="detail">
      <Box mb={2}>
        <Button variant="outlined" onClick={() => history.push("/identities")}>
          ← Back to Identities List
        </Button>
      </Box>

      <AlignedListContainer maxWidth="xl">
        <DetailSection title="Identity Information">
          <ListItem>
            <ListItemText>
              <strong>ID:</strong> {identity.id}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <strong>First Name:</strong> {identity.firstName || "(not set)"}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <strong>Last Name:</strong> {identity.lastName || "(not set)"}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <strong>Status:</strong>{" "}
              <IdentityStatusBadge status={identity.status} />
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <strong>Date of Birth:</strong>{" "}
              {identity.dob ? (
                <Time format="MMM DD, YYYY">{identity.dob}</Time>
              ) : (
                "(not set)"
              )}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <strong>SSN:</strong>{" "}
              {identity.ssn ? (
                <HiddenSsnDisplay value={identity.ssn} />
              ) : (
                "(not set)"
              )}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <strong>Date of Birth:</strong>{" "}
              {identity.dob
                ? new Date(identity.dob).toISOString().split("T")[0]
                : "(not set)"}
            </ListItemText>
          </ListItem>
          <ListItem>
            <ListItemText>
              <strong>Updated At:</strong>{" "}
              {identity.updatedAt ? (
                <Time format="MMM DD, YYYY HH:mm:ss">{identity.updatedAt}</Time>
              ) : (
                "(not set)"
              )}
            </ListItemText>
          </ListItem>
        </DetailSection>

        <DetailSection title="Associated Customers" mt={5}>
          {identity.customers && identity.customers.length > 0 ? (
            <SimpleTable
              truncated
              tableProps={{ size: "small" }}
              headers={["Customer ID", "Email", "Name", "Phone"]}
              rows={identity.customers}
              keyRowAttr="id"
              toCells={(row) => [
                <Link key={1} to={`/customers/${row.id}`}>
                  {row.id}
                </Link>,
                row.email || "(not set)",
                row.name || "(not set)",
                row.phone ? displayPhone(row.phone) : "(not set)"
              ]}
            />
          ) : (
            <Typography variant="body2" color="textSecondary">
              No customers associated with this identity.
            </Typography>
          )}
        </DetailSection>
      </AlignedListContainer>
    </AdminContainer>
  );
}
